module.exports = __webpack_public_path__ + "static/media/img2-2.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cebolla/nutricheck_foliar/B/img2-2.png
// module id = 1361
// module chunks = 3